import { useEffect, useMemo, useState } from 'react';

export const SHOW_MORE_LENGTH = 4;

export const useShowMoreItems = <T>(
  items: T[],
  isMobile: boolean,
  isTabletOrMobile: boolean
): {
  showAllItems: boolean;
  setShowAllItems: (value: boolean) => void;
  showMoreButtonShown: boolean;
  visibleItems: T[];
} => {
  const [showAllItems, setShowAllItems] = useState(false);

  const showMoreButtonShown = useMemo(() => {
    if (isTabletOrMobile || items.length <= SHOW_MORE_LENGTH) return false;
    return items.length > SHOW_MORE_LENGTH;
  }, [items.length, isTabletOrMobile]);

  useEffect(() => {
    setShowAllItems(isMobile);
  }, [isMobile]);

  const visibleItems = useMemo(() => {
    if (isTabletOrMobile || items.length <= SHOW_MORE_LENGTH || showAllItems) return items;
    return items.slice(0, SHOW_MORE_LENGTH);
  }, [isTabletOrMobile, items, showAllItems]);

  return { showAllItems, setShowAllItems, showMoreButtonShown, visibleItems };
};
